"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRange = getRange;
exports.getRangeMinMaxDate = getRangeMinMaxDate;
exports.getRangeValue = getRangeValue;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function getRangeValue(dates, _ref) {
  var startOfItem = _ref.startOfItem,
    endOfItem = _ref.endOfItem;
  return dates.sort(function (a, b) {
    return a - b;
  }).map(function (d, i) {
    switch (i) {
      case 0:
        return startOfItem(d);
      case 1:
        return endOfItem(d);
      default:
        return d;
    }
  });
}
function getRangeMinMaxDate(range, _ref2, viewHelpers) {
  var initialMinDate = _ref2.minDate,
    initialMaxDate = _ref2.maxDate;
  return range.map(function (_date, i) {
    var first = i === 0;
    var last = i === range.length - 1;
    var prev = range[i - 1];
    var next = range[i + 1];
    return {
      minDate: first ? initialMinDate : viewHelpers.nextView(prev),
      maxDate: last ? initialMaxDate : viewHelpers.previousView(next)
    };
  });
}
function getRange() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var emptyStartDate = arguments.length > 1 ? arguments[1] : undefined;
  var viewHelpers = arguments.length > 2 ? arguments[2] : undefined;
  var openPeriod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _value = _slicedToArray(value, 2),
    start = _value[0],
    end = _value[1];
  if (!start && !end) {
    var emptyDate = viewHelpers.startOfView(emptyStartDate);
    return [viewHelpers.previousView(emptyDate), emptyDate];
  } else if (!end || viewHelpers.isSameView.apply(viewHelpers, _toConsumableArray(value))) {
    var current = viewHelpers.startOfView(start);
    if (openPeriod) {
      var endDate = viewHelpers.startOfView(emptyStartDate);
      return [viewHelpers.isSameView(current, endDate) ? viewHelpers.previousView(current) : current, endDate];
    }
    return [viewHelpers.previousView(current), current];
  } else {
    return [viewHelpers.startOfView(start), viewHelpers.startOfView(end)];
  }
}